import { useState } from "react";
import { Share2, Check } from "lucide-react";
import { useLanguage } from "@/lib/LanguageContext";
import { base44 } from "@/api/base44Client";

export default function ShareComparisonButton({ ids }) {
  const { language } = useLanguage();
  const [copied, setCopied] = useState(false);
  const isPl = language === "pl";

  if (!ids || ids.length < 2) return null;

  const track = () =>
    base44.analytics.track({ eventName: "compare_link_shared", properties: { count: ids.length } });

  const handleShare = async () => {
    const url = window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({ title: "Porównanie odmian - TerpeneAtlas", url });
        track();
        return;
      } catch (e) {
        if (e?.name === "AbortError") return; // user canceled
        // share blocked (e.g. inside iframe) — fall back to copy
      }
    }
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      if (!ok) return;
    }
    track();
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      onClick={handleShare}
      className="inline-flex items-center gap-1.5 px-3 py-2 min-h-[44px] rounded-lg border border-border bg-card text-sm font-medium text-muted-foreground hover:text-foreground hover:border-primary/30 transition-colors"
    >
      {copied ? <Check className="w-4 h-4 text-green-600" /> : <Share2 className="w-4 h-4" />}
      {copied ? (isPl ? "Link skopiowany" : "Link copied") : (isPl ? "Udostępnij" : "Share")}
    </button>
  );
}